<div class="wrapper page-privacy-policy">
  <div class="content">
    @if ((program$ | async);as program) {
      <h1>{{ program.name }}</h1>
      <br>
      {{ program.termsAndConditions }}
    }
    @if ((error$ | async);as error) {
      <app-input-errors
          translationKey="errors.programs"
          [errorsForField]="{error: error}"/>
    }
  </div>
</div>
